<script>
  import {mapActions} from 'vuex';
  import moduleUtils from 'src/app/module/ModuleUtils';
  import SgsRenderNotificationSuccess from 'src/components/utils/sgs/SgsRenderNotificationSuccess.vue';
  import SgsRenderNotificationError from 'src/components/utils/sgs/SgsRenderNotificationError.vue';

  export default {
    props: ["attr", "formIdentifier", "fieldValue", "instance"],
    data () {
      return {
        notificationError: null,
        notificationSuccess: null,
        localDataTable: []
      }
    },
    components: {
      SgsRenderNotificationSuccess,
      SgsRenderNotificationError
    },
    methods: {
      ...mapActions([
        'showLoader',
        'hideLoader'
      ]),
      renderIcon: function(icon) {
        return ("glyphicon glyphicon-" + icon);
      },
      callBusinessRule: function(businessRuleId, instance) {

        this.showLoader();

        moduleUtils.callBusinessRule(this.formIdentifier, instance, businessRuleId)
          .then(response => {

            this.hideLoader();

            _.forOwn(response.body.instance, (value, key) => {
              this.$set(instance, key, value);
            });

            this.notificationError = response.body.notificationError;
            this.notificationSuccess = response.body.notificationSuccess;
          })
      },
      actionButton: function(button, fieldsDataRow) {
        if (button.type === 'ACTION' || !button.type) {
          this.callBusinessRule(button.businessRule.id, fieldsDataRow);
        } else if (button.type === 'REPORT') {
          this.doGenerateReport(fieldsDataRow, button.form.id);
        } else if (button.type === 'LINK') {
          this.$emit('actionLinkSelected', button.form.id, fieldsDataRow);
        }
      },
      doGenerateReport: function (fieldsDataRow, formId) {
        this.showLoader();

        let formIdentifier = Object.assign({}, this.formIdentifier);
        formIdentifier.formId = formId

        moduleUtils.moduleFormGenerateReport(formIdentifier, fieldsDataRow, true)
          .then(response => {

            this.hideLoader();

            this.notificationError = response.body.notificationError;
            this.notificationSuccess = response.body.notificationSuccess;

            if (response.meta.code == 400) {

              _.forOwn(response.body.instance, (value, key) => {
                this.$set(this.instance, key, value);
              });

            } else if (response.meta.code == 500) {

              this.$notify({
                title: 'Error',
                message: this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
                type: 'error'
              });
            }
          });
      },
      returnBackgroundColor: function(backgroundColor) {
        if (backgroundColor) {
          return "background-color: " + backgroundColor + "; color: white;";
        }
        return "";
      },
      handleSelectionChange(val) {
        if(val.length > 0) {
          this.instance[this.attr.columnName + "_selected"] = val;
        }
      },
      differenceBetweenTwoArrays: function(array1, array2) {
        let listToReturn = [];

        array1.forEach(item => {
          let itemToAddOnList = _.find(array2, { 'id': item.id});

          if(itemToAddOnList === undefined) {
            listToReturn.push(item);
          }
        });

        return listToReturn;
      },
      getHeader: function(header) {

        let label = header.labelPt;

        if (this.$i18n.locale == 'es' && header.labelEs) {
          label = header.labelEs;
        } else if (this.$i18n.locale == 'en' && header.labelEn) {
          label = header.labelEn;
        }

        return label;
      },
      getButtonHint: function(button) {

        let hint = button.hintPt;

        if (this.$i18n.locale == 'es' && button.hintEs) {
          hint = button.hintEs;
        } else if (this.$i18n.locale == 'en' && button.hintEn) {
          hint = button.hintEn;
        }

        return hint;
      }
    },
    watch: {
      "fieldValue": function (newVal, oldVal) {

        this.localDataTable = [];
        this.localDataTable = newVal;

      }
    },
    computed: {
      widthIcons: function() {
        let sizeOfColumnActions = this.attr.actions.length * 40;
        //ESSE CODIGO FOI COLOCADO, PARA NÃO QUEBRAR O LAYOUT DA COLUNA AÇÕES
        if (sizeOfColumnActions < 100) {
          return "100px";
        }

        return sizeOfColumnActions + "px";
      },
      getHeaders: function() {

        let ret = [];

        this.attr.headers.map(it => {

          let visible = true;

          if (this.$i18n.locale == 'pt' && it.visibleToPt != undefined) {
            visible = it.visibleToPt;
          } else if (this.$i18n.locale == 'es' && it.visibleToEs != undefined) {
            visible = it.visibleToEs;
          } else if (this.$i18n.locale == 'en' && it.visibleToEn != undefined) {
            visible = it.visibleToEn;
          }

          if (visible) {
            ret.push(it);
          }
        });

        return ret;
      }
    },
    mounted: function () {
      if (this.attr.multipleSelect) {
        this.instance[this.attr.columnName + "_selected"] = [];
      }
    }
  }
</script>

<template>
  <div class="row">

    <SgsRenderNotificationSuccess v-model="notificationSuccess"/>
    <SgsRenderNotificationError v-model="notificationError"/>

    <div class="col-md-12">

      <el-table
        :data="localDataTable"
        stripe
        class="margin-bottom-15"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40" v-if="attr.multipleSelect"></el-table-column>
        <el-table-column :label="$t('actions')" :width="widthIcons" v-if="attr.actions.length > 0">
          <template scope="scope">
            <td v-if="attr.actions.length > 0" :data-th="$t('actions')">
              <el-button
                v-for="button in attr.actions"
                size="mini"
                :style="returnBackgroundColor(button.backgroundColor)"
                :title="getButtonHint(button)"
                @click.prevent="actionButton(button, row)">
                <i :class="renderIcon(button.icon)"/>
              </el-button>
            </td>
          </template>
        </el-table-column>

        <el-table-column v-for="header in getHeaders" :label="getHeader(header)" :prop="header.value"></el-table-column>

      </el-table>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderGrid.vue?5728f8b1